export default function productivityColor(productivityPercent) {
    
  if (productivityPercent >= 1 && productivityPercent < 30) return 'danger'
  if (productivityPercent >= 30 && productivityPercent < 60) return 'warning'
  if (productivityPercent >= 60 && productivityPercent <= 100) return 'green'

  return ''
}
